import { render, staticRenderFns } from "./liuCheng.vue?vue&type=template&id=119889e4&scoped=true"
import script from "./liuCheng.vue?vue&type=script&lang=js"
export * from "./liuCheng.vue?vue&type=script&lang=js"
import style0 from "./liuCheng.vue?vue&type=style&index=0&id=119889e4&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "119889e4",
  null
  
)

export default component.exports